import * as CoberturaProvider from "../providers/cobertura-provider";
import * as GeneralRepository from "../repositories/general-repository";
import * as ProductoMapper from "../mappers/producto-mapper";

export const obtenerAliasCoberturas = async (productos) => {
    const request = ProductoMapper.mapProductosToCoberturas(productos)
    const response = await CoberturaProvider.obtenerAliasCoberturas(request)
    if(response && response.datos !== undefined && response.datos !== null) {
        return {
            error: null,
            aliasCoberturas: response.datos
        }
    } else {
        return {
            error: response,
            aliasCoberturas: null
        }
    }
}

export const obtenerTextosCoberturas = async (productos) => {
    const request = ProductoMapper.mapProductosToCodigosCoberturas(productos)
    const response = await CoberturaProvider.obtenerTextosCoberturas(request)
    if(response && response.datos !== undefined && response.datos !== null) {
        return {
            error: null,
            textosCoberturas: response.datos
        }
    } else {
        return {
            error: response,
            textosCoberturas: null
        }
    }
}